/**
 * FormatoArquivoRelatorioCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'

/* TODO: review generated class */
@HttpExclude()
export class FormatoArquivoRelatorioCollection extends PageCollection<
  FormatoArquivoRelatorio
> {
  constructor() {
    super(FormatoArquivoRelatorio)
  }

  queryAsPage() {
    return this.listFormatoArquivoRelatorio()
  }

  async listFormatoArquivoRelatorio() {
    return await Request.get(`/admin/formato-arquivo-relatorio`, {
      params: this.params,
    })
      .name('listFormatoArquivoRelatorio')
      .as(this)
      .getResponse()
  }

  async listCsvFormatoArquivoRelatorio() {
    return await Request.get(`/admin/formato-arquivo-relatorio/csv`, {
      params: this.params,
    })
      .name('listCsvFormatoArquivoRelatorio')
      .as(this)
      .getResponse()
  }
}
